/**
 * @module ad
 * @description 广告模块
 * @author: Teacher Tang
 * @date: 2019-09-06 10:31:27
 */
import { utils, ajax } from '../index';
/**
 * 获取id 方法
 * @function
 * @param {string} platform 平台，默认是pc, pc-PC端, app-移动App, m-H5站点, zhaopin-黄豆, ent-企业版
 */

export var showPopup = function showPopup(platform) {
  if (platform === void 0) {
    platform = 'pc';
  }

  var now = new Date();
  var date = now.getFullYear() + "." + (now.getMonth() + 1) + "." + now.getDate();
  var preset = utils.getSitePreUrl('www');
  ajax.getJson(preset + "/api/v2/activity/popup", {
    platform: platform,
    popup_type: 1
  }).then(function (res) {
    if (res.error_code === 0 && res.popup) {
      var popup_1 = res.popup; // 显示频次, day:每日显示一次, visit:每次访问都显示

      if (localStorage[date + 'frequency'] && popup_1.frequency !== 'visit' && localStorage[date + 'frequency'] !== 'visit') {
        return;
      }

      if (popup_1.link) {
        popup_1.link = popup_1.link.replace('http://', '').replace('https://', '');
      }

      localStorage[date + 'frequency'] = popup_1.frequency; // 显示时长, 单位: 秒, 0表示不限时

      if (popup_1.persist) {
        setTimeout(function () {
          document.body.removeChild(modal_1);
          document.body.style.overflowY = 'auto';
        }, popup_1.persist * 1000);
      } // 广告弹层


      var modal_1 = document.createElement('div');
      modal_1.setAttribute('style', "\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        overflow: auto;\n        margin: 0;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.5);\n        z-index: 999;\n        cursor: default;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        align-content: center;\n      "); // 关闭按钮

      var closeDom = document.createElement('img');
      closeDom.setAttribute('style', "position: absolute;\n        right: 0;\n        top: 0;\n        cursor: pointer;\n        display: inline-block;\n        width: 32px;\n        height: 32px;\n      ");
      closeDom.src = "https://static.clouderwork.com/startup/78/70/dee29d53-3155-4cdd-9f96-753140fd983e.png";
      closeDom.addEventListener('click', function (e) {
        document.body.removeChild(modal_1);
        document.body.style.overflowY = 'auto';
        e.preventDefault();
        e.stopPropagation();
      }); // 广告链接

      var rowDom = document.createElement('div');
      rowDom.setAttribute('style', "position: absolute;\n        right: -150px;\n        top: 0;\n      ");

      if (popup_1.persist) {
        // 倒计时按钮
        var timeDom_1 = document.createElement('span');
        timeDom_1.setAttribute('style', "position: absolute;\n          right: 46px;\n          top: 0;\n          display: flex;\n          align-items: center;\n          min-width: 64px;\n          height: 32px;\n          background: url('https://static.clouderwork.com/startup/d9/9c/7729a40c-4816-4c8a-9197-944f82804232.png') no-repeat left center;\n          background-size: 100% 32px;\n          font-size: 16px;\n          padding: 0 12px 0 32px;\n          box-sizing: border-box;\n          color: #fff;");
        var second_1 = popup_1.persist;
        timeDom_1.innerText = second_1 + 's';
        var timer_1 = setInterval(function () {
          second_1 -= 1;

          if (second_1 === 0) {
            clearInterval(timer_1);
          }

          timeDom_1.innerText = second_1 + 's';
        }, 1000);
        rowDom.appendChild(timeDom_1);
      } else {
        rowDom.setAttribute('style', "position: absolute;\n          right: -72px;\n          top: 0;\n          ");
      }

      rowDom.appendChild(closeDom); // 广告链接

      var linkDom = document.createElement('a');
      linkDom.href = "//" + popup_1.link;
      linkDom.target = '_blank';
      linkDom.style.maxWidth = '70%';
      linkDom.style.maxHeight = '85%';
      linkDom.style.position = 'relative'; // 广告图片

      var picDom = document.createElement('img');
      picDom.src = popup_1.pic_url;
      picDom.style.display = 'inline-block';
      picDom.style.maxWidth = '100%';
      picDom.style.maxHeight = document.body.offsetHeight - 100 + 'px';
      picDom.addEventListener('click', function () {
        // 埋点统计
        if (window.AnalysysAgent) {
          window.AnalysysAgent.track('banner_ywk_tanchuang', {
            item_title: '云沃客',
            resource_id: 'banner_ywk_tanchuang',
            resource_item: '首页',
            resource_name: '弹窗广告',
            resource_type: 'banner'
          });
        }

        ajax.getJson(preset + "/api/v2/activity/popup", {
          popup_id: popup_1.id
        });
      });
      linkDom.appendChild(rowDom);
      linkDom.appendChild(picDom);
      modal_1.appendChild(linkDom);
      document.body.appendChild(modal_1); // document.body.style.overflowY = 'hidden'
      // document.body.style.overflowX = 'hidden'
    }
  });
};